var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('compFormEdit',{staticClass:"margin-top-15 margin-right-15",attrs:{"formdata":_vm.getBase,"labelWidth":120},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}}),_c('div',[_c('vButton',{attrs:{"theme":"primary"}},[_vm._v("保存")]),_c('vButton',[_vm._v("取消")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }